// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

const isProduction = _ENV_ === 'production';
const isTest = _ENV_ === 'test';
const isQa = _ENV_ === 'qa';
const buildVersion = '[AIV]{version}[/AIV]';

export const BUILD_VERSION = buildVersion;

export const DD_ENV =
  (isProduction && 'prod') ||
  (isTest && 'stage') ||
  'dev';

export const URL =
(isProduction && 'https://cloud.airworks.io') ||
(isTest && 'https://test.cloud.airworks.io') ||
(isQa && 'https://qa.cloud.airworks.io') ||
'https://dev.cloud.airworks.io';

export const API_URL =
  (isProduction && 'https://api.airworks.io') ||
  (isTest && 'https://test.api.airworks.io') ||
  (isQa && 'https://qa.api.airworks.io') ||
    'https://dev.api.airworks.io';

export const S3_STORAGE_URL =
  (isProduction && 'https://fileupload.airworks.io') ||
  (isTest && 'https://test.fileupload.airworks.io') ||
  (isQa && 'https://qa.fileupload.airworks.io') ||
  'https://dev.fileupload.airworks.io';

export const CAD_OUTPUTS_URL =
  (isProduction && 'https://cadoutputs.airworks.io') ||
  (isTest && 'https://test.cadoutputs.airworks.io') ||
  (isQa && 'https://qa.cadoutputs.airworks.io') ||
  'https://dev.cadoutputs.airworks.io';

const TERMS_AND_CONDITIONS_URL =
  'https://airworks-terms-and-conditions-files-prod.s3.amazonaws.com';

export const MAPBOX_URL = 'https://api.mapbox.com/geocoding/v5';

export const MAP_TILESERVER_URL =
  (isProduction && 'https://tiles.airworks.io') ||
  (isTest && 'https://test.tiles.airworks.io') ||
  (isQa && 'https://qa.tiles.airworks.io') ||
  'https://dev.tiles.airworks.io';

export const LOCALE = 'en-US';

export const STRIPE_URL = 'https://api.stripe.com/v1';

export const MAP_LAYERS_POLLING_INTERVAL_IN_MILLISECONDS = 3000;
export const MAP_HIGH_RES_TILES_POLLING_INTERVAL_IN_MILLISECONDS = 30000;

export const GetEsriGeoJsonUrl = (fullUrl: string) => {
  const path = new globalThis.URL(fullUrl).pathname;
  return `${CAD_OUTPUTS_URL}${path}`;
};

export const GetTifFileSizeUrl = ({ fileName, orgId, projectId }: { fileName: string, orgId: string, projectId: string }) => (
  `${S3_STORAGE_URL}/${orgId}/${projectId}/${fileName}.tif`
);

export const GetRasterMetadataUrl = ({ fileName, orgId, projectId }: { fileName: string, orgId: string, projectId: string }) => (
  `${MAP_TILESERVER_URL}/${orgId}/${projectId}/${fileName}/metadata.json`
);

export const GetRasterLogFileUrl = (userId: string, projectId: string, fileName: string) => (
  `${MAP_TILESERVER_URL}/${userId}/${projectId}/${fileName}/log.txt`
);

export const GetVectorMetadataUrl = (userId: string, projectId: string, orderId: string, fileVersion: string) => (
  `${MAP_TILESERVER_URL}/${userId}/${projectId}/${orderId}/${fileVersion}/metadata.json`
);

export const GetTermsAndConditionsUrl = (html: string) => (
  `${TERMS_AND_CONDITIONS_URL}/${html}`
);

export const GetRasterTilePbfUrl = ({ fileName, orgId, projectId, isTms }: { fileName: string; orgId: string; projectId: string; isTms: boolean; }) => (
  isTms ?
    `${MAP_TILESERVER_URL}/${orgId}/${projectId}/${fileName}/{z}/{x}/{y}.png` :
    `${MAP_TILESERVER_URL}/${orgId}/${projectId}/${fileName}/{z}/{x}/{y}.pbf`
);

export const GetVectorTilePbfUrl = (userId: string, projectId: string, orderId: string, fileVersion: string) => (
  `${MAP_TILESERVER_URL}/${userId}/${projectId}/${orderId}/${fileVersion}/{z}/{x}/{y}.pbf`
);

export const GetElevationLabelsMajrUrl = (userId: string, projectId: string, orderId: string, fileVersion: string) => (
  `${MAP_TILESERVER_URL}/${userId}/${projectId}/${orderId}/${fileVersion}/topo_elevations_majr.geojson`
);

export const GetElevationLabelsMinrUrl = (userId: string, projectId: string, orderId: string, fileVersion: string) => (
  `${MAP_TILESERVER_URL}/${userId}/${projectId}/${orderId}/${fileVersion}/topo_elevations_minr.geojson`
);
